import React from 'react';
import ManutencaoFiscalNfceContent from './ManutencaoFiscalNfceContent';
import { ManutencaoFiscalNfceProvider } from './ManutencaoFiscalNfceContext';

const ManutencaoFiscalNfce: React.FC = () => {
  function defaultOnlyReport() {
    return false;
  }
  return (
    <ManutencaoFiscalNfceProvider>
      <ManutencaoFiscalNfceContent />
    </ManutencaoFiscalNfceProvider>
  );
};

export default ManutencaoFiscalNfce;
